/**
 * Copy text to the clipboard: the async Clipboard API when available in a
 * secure context, else a `document.execCommand('copy')` fallback via a
 * temporary off-screen `<textarea>`. Throws if both paths fail so callers can
 * surface an error (e.g. a toast) — this module has no UI opinion of its own.
 *
 * Mirrors `source/js/modules/activity-log/utils/copyToClipboard.js` — kept
 * as a module-local copy rather than a cross-module import so calendar-month
 * doesn't depend on the activity-log module for an unrelated feature.
 */

const copyViaExecCommand = text => {
	const textarea = document.createElement('textarea');
	textarea.value = text;
	textarea.style.position = 'fixed';
	textarea.style.opacity = '0';
	document.body.appendChild(textarea);
	textarea.focus();
	textarea.select();
	const succeeded = document.execCommand('copy');
	document.body.removeChild(textarea);
	if (!succeeded) throw new Error('execCommand copy failed');
};

/**
 * @param {string} text
 * @returns {Promise<void>}
 */
export async function copyToClipboard(text) {
	if (navigator.clipboard && window.isSecureContext) {
		await navigator.clipboard.writeText(text);
	} else {
		copyViaExecCommand(text);
	}
}

export default copyToClipboard;
